module.exports = __webpack_public_path__ + "img/logo-sm.62956ce5.svg";